import { z } from 'zod';

/**
 * 企業契約期間 編集フォームのバリデーションスキーマ
 *
 * 編集可能項目: contractPlanId / startedOn / endedOn
 *
 * バリデーションルール:
 * - contractPlanId: 必須（空文字不可）
 * - startedOn: 必須（Date型）
 * - endedOn: Date型または null（無期限）。設定する場合は startedOn 以降の日付であること
 * - ended_on_min の検証は DatePicker の fromDate で制御し、突破された場合はサーバー側 422 で拾う
 */
export const editClientContractTermSchema = z
  .object({
    /** 契約プランID（編集可能） */
    contractPlanId: z.string().trim().min(1, '契約プランを選択してください。'),
    /** 利用開始日（編集可能） */
    startedOn: z.date({ message: '開始日を入力してください。' }),
    /** 利用終了日（編集可能・無期限の場合は null） */
    endedOn: z.date({ invalid_type_error: '終了日を入力してください。' }).nullable(),
  })
  .refine(
    data => {
      if (data.endedOn == null) return true;
      return data.endedOn >= data.startedOn;
    },
    {
      message: '終了日は開始日以降の日付を入力してください。',
      path: ['endedOn'],
    }
  );

export type EditClientContractTermFormValues = z.infer<typeof editClientContractTermSchema>;
